import { roNodeInitialState } from "./ROConfig.slice";

/**
 * Returns the per-node state for the given nodeId, falling back to the
 * default empty-node shape when the node hasn't been initialised yet.
 *
 * Usage:  useSelector(selectROInstance(nodeId))
 */
export const selectROInstance = nodeId => state => state.ROConfig.nodes[nodeId] ?? roNodeInitialState;

/**
 * Returns the per-node state for whichever RO node is currently active.
 * This is what the majority of RO components / hooks should use.
 *
 * Usage:  useSelector(selectActiveROInstance)
 */
export const selectActiveROInstance = state => {
  const { nodes } = state.ROConfig;
  const activeNodeId = state.projectInfo.projectActiveTab;
  return nodes[activeNodeId] ?? roNodeInitialState;
};

/**
 * Returns the nodeId of the currently active RO node.
 *
 * Usage:  useSelector(selectROActiveNodeId)
 */
export const selectROActiveNodeId = state => state.projectInfo.projectActiveTab;

/**
 * Returns all RO nodes keyed by nodeId.
 *
 * Usage:  useSelector(selectAllRONodes)
 */
export const selectAllRONodes = state => state.ROConfig.nodes;

/**
 * Returns true when any RO node has unsaved changes.
 * Used by useSaveProjectData to drive the project-level dirty flag.
 *
 * Usage:  useSelector(selectIsAnyRODataUpdated)
 */
export const selectIsAnyRODataUpdated = state => Object.values(state.ROConfig.nodes).some(node => node.isRODataUpdated);

export const selectIsAnyCCRODataUpdated = state =>
  Object.values(state.ROConfig.nodes).some(node => node.isCCRODataUpdated);

export const selectIsAnyRONodeSmallCommercial = state =>
  Object.values(state.ROConfig.nodes).some(node => node.roConfig?.isSmallCommercial === true);
